module.exports = __webpack_public_path__ + "assets/img/about.f0ef0e3f.png";